import MoveTaskToGroup from "@common-components/tasks-panel/bulk-actions-dialog/move-to/move-task-to-group";
import { bulkActions } from "@common-reducers/BulkActionsReducer";
import { taskGroupsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { Circle } from "@mui/icons-material";
import { Box, Menu, Stack } from "@mui/material";
import { useState } from "react";
import { CellProps } from "../cell-interface";

export default function GroupCell({ groupId, taskId, boardId }: CellProps) {
  const dispatch = useAppDispatch();
  const [open, setIsOpen] = useState<boolean>(false)


  const group = useAppSelector((state) => taskGroupsSelectOneObjectByQuery(state.DBTaskgroupsReducer, { _id: groupId }))

  const togglePicker = () => {
    dispatch(bulkActions.setMovingTo('group'))
    setIsOpen(true)
  }
  const anchor = `group_${taskId}`
  const anchorEl = document.getElementById(anchor)
  const onClickAway = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Stack id={anchor} onClick={togglePicker} direction={"row"} alignItems={"center"} sx={{ flex: 1, fontSize: "14px", px: 1, cursor: "pointer" }}>
        <Circle sx={{ fontSize: "14px", color: group?.colorAccent, marginInlineEnd: "4px" }} />
        <Box sx={{ marginInlineStart: "15px" }}>{group?.name}</Box>
      </Stack>
      <Menu
        sx={{ "padding": '0 10px' }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={onClickAway}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MoveTaskToGroup bulkTasksList={[]} activeTaskid={taskId ?? ""} boardId={boardId ?? ""} onMoveComplete={(status) => {
          setIsOpen(status)
        }} />
      </Menu>
    </>

  );
}
